module.exports = __webpack_public_path__ + "img/2.dfbe4685.jpg";